var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistoryCalendar = function SvgHistoryCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 3.887h-4.302V2.5h-1.025v1.383l-6.36.002V2.5H5.788v1.383L1.5 3.885V17.5h17V3.887Zm-12.698.984v.797h1.025v-.813h6.36v.797h1.025v-.797h3.294v2.341H2.508V4.855l3.294.016ZM2.508 16.528V8.167h14.984v8.361H2.508Z",
    fill: "#666"
  })));
};
export default SvgHistoryCalendar;